/**
 * RESPONSIBILITY: whether a column is asked for in this row.
 *
 * PRESENTATION. Hiding a field neither clears it nor forbids it — the value already
 * saved stays saved and comes back the moment the condition is true again. An editor who
 * picks the wrong theme, types nothing and picks the right one has lost nothing, which is
 * the difference between a form that guides and one that punishes.
 *
 * The named field is a SIBLING, looked up in the same row. That is the whole of the
 * language on purpose: a condition able to reach across the document is one an editor
 * cannot predict from what is in front of them.
 */
import type { ItemField } from './cell-types';

export function visible(f: ItemField, row: Record<string, unknown>): boolean {
  if (!f.showWhen) return true;
  const v = row[f.showWhen.field];
  const held = Array.isArray(v) ? v.map(String) : [String(v ?? '')];
  return f.showWhen.is.some((want) => held.includes(want));
}
